<template>
  <section class="messaging-protection">
    <h1>Messaging Protection</h1>
    <p>Separate evaluation from active release protection for outgoing messages.</p>
    <nav aria-label="Messaging protection categories" class="protection-nav">
      <RouterLink :to="{ name: STAFF_PUMPING_PROTECTION }"> Pumping Protection <span>Evaluation</span> </RouterLink>
      <RouterLink :to="{ name: STAFF_MESSAGING_PROTECTION }">
        Messaging Protection <span>Active protection</span>
      </RouterLink>
    </nav>
    <RouterView />
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { RouterLink, RouterView } from 'vue-router'
import { STAFF_MESSAGING_PROTECTION, STAFF_PUMPING_PROTECTION } from '@/types/router'

export default defineComponent({
  name: 'MessagingProtectionBase',
  components: { RouterLink, RouterView },
  setup() {
    return { STAFF_MESSAGING_PROTECTION, STAFF_PUMPING_PROTECTION }
  },
})
</script>
